import React, { useEffect } from "react";
import { Container, Nav, Tab } from "react-bootstrap";
import { FunnelAnalyticsView } from "../views/analytics/FunnelAnalyticsView";
import { useLocalAnalyticsState } from "../../graphql/hooks";
import { useApolloClient } from "@apollo/client";
import { AnalyticsStateData } from "../../models/types";
import { GET_LOCAL_ANALYTICS_STATE } from "../../graphql/queries";
import { BackButton } from "../simple/BackButton";
import { useLocation, useNavigate, useNavigationType } from "react-router-dom";
import {
    clearFunnelSelection,
    updateAnalyticsState
} from "../../common/AnalyticsHelpers";
import { QueryGuide } from "../views/analytics/QueryGuide";
import { QueryHeader } from "../headers/QueryHeader";
import cx from "classnames";
import styles from "../pages/FunnelView.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";

export const AnalyticsPlayground = () => {
    const analyticsState = useLocalAnalyticsState();
    const client = useApolloClient();
    const navigate = useNavigate();
    const location = useLocation();
    const navigationType = useNavigationType();

    const updateCurrentTab = (tab: string) => {
        client.writeQuery<AnalyticsStateData, AnalyticsStateData>({
            query: GET_LOCAL_ANALYTICS_STATE,
            data: {
                analyticsState: {
                    ...analyticsState,
                    analyticsSelectedTab: tab
                }
            }
        });
    };

    useEffect(
        () => {
            return () => {
                const currentAnalyticsState =
                    client.readQuery<AnalyticsStateData>({
                        query: GET_LOCAL_ANALYTICS_STATE
                    });
                if (currentAnalyticsState?.analyticsState.clearCache) {
                    clearFunnelSelection(client);
                } else {
                    updateAnalyticsState(client, {
                        ...analyticsState,
                        clearCache: true
                    });
                }
            };
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    return (
        <>
            <div className={cx(styles.backButton, "mb-3 mb-xl-0")}>
                <BackButton
                    hasHistory={!(location.key && navigationType === "POP")}
                    goBack={() => navigate(-1)}
                    size={"lg"}
                />
            </div>
            <Container className={`${styles.responsiveContainer}`}>
                <Tab.Container activeKey={analyticsState.analyticsSelectedTab}>
                    <Nav
                        variant="tabs"
                        onSelect={eventKey => {
                            updateCurrentTab(eventKey || "funnels");
                        }}
                        className="d-flex"
                    >
                        <QueryHeader />
                        <Nav.Item className="ms-auto justify-content-end">
                            <Nav.Link eventKey="funnels">Funnels</Nav.Link>
                        </Nav.Item>
                        <Nav.Item className="justify-content-end">
                            <Nav.Link eventKey="guide">
                                Guide
                                <FontAwesomeIcon
                                    icon={faCircleQuestion}
                                    className="ms-2 text-inverse-75"
                                />
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>
                    <Tab.Content>
                        <Tab.Pane eventKey="funnels">
                            {analyticsState.analyticsSelectedTab ===
                            "funnels" ? (
                                <FunnelAnalyticsView />
                            ) : null}
                        </Tab.Pane>
                        <Tab.Pane eventKey="guide">
                            <QueryGuide />
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>
            </Container>
        </>
    );
};
